(function () {
  'use strict';
  var watchedImages = new WeakSet();

  function prepareImage(image) {
    if (watchedImages.has(image)) return;
    watchedImages.add(image);
    function update() {
      var frame = image.closest('.poza');
      if (frame) frame.classList.toggle('has-hover-image', image.complete && image.naturalWidth > 1);
    }
    image.addEventListener('load', update);
    image.addEventListener('error', function () {
      var frame = image.closest('.poza');
      if (frame) frame.classList.remove('has-hover-image');
    });
    update();
  }

  function process(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('img[data-card-secondary]')) prepareImage(root);
    root.querySelectorAll('img[data-card-secondary]').forEach(prepareImage);
  }

  function init() {
    process(document.body);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(process);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
